import React, { useEffect } from 'react';
import "./Notification.css"

const Notification = (props) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            props.close();
        }, 3000); 
        return () => clearTimeout(timer);
    }, []); 

    return (
        <div className="notification">
            <button className="close-button " onClick={props.close}>X</button>
            {props.message}
        </div>
    );
}

export default Notification;
